import isTouch from '../util/touch';

var modelJsonSections = {};
var models = {};
var xrButtons = {};

const selectors = {
  productMediaWrapper: '[data-product-single-media-wrapper]',
  productSlideshow: '[data-product-slideshow]',
  productXr: '[data-shopify-xr]',
  dataMediaId: 'data-media-id',
  dataModelId: 'data-model-id',
  modelViewer: 'model-viewer',
  dataModel3d: 'data-shopify-model3d-id',
  modelJson: '#ModelJson-',
};

export default function initSectionModels(modelViewerContainer, sectionId) {
  modelJsonSections[sectionId] = {
    loaded: false,
  };

  const mediaId = modelViewerContainer.getAttribute(selectors.dataMediaId);
  const modelViewerElement = modelViewerContainer.querySelector(selectors.modelViewer);
  const modelId = modelViewerElement.getAttribute(selectors.dataModelId);
  const xrButton = modelViewerContainer.closest(selectors.productSlideshow).parentElement.querySelector(selectors.productXr);
  xrButtons[sectionId] = {
    $element: xrButton,
    defaultId: modelId,
  };

  models[mediaId] = {
    modelId: modelId,
    mediaId: mediaId,
    sectionId: sectionId,
    $container: modelViewerContainer,
    $element: modelViewerElement,
  };

  window.Shopify.loadFeatures([
    {
      name: 'shopify-xr',
      version: '1.0',
      onLoad: setupShopifyXr,
    },
    {
      name: 'model-viewer-ui',
      version: '1.0',
      onLoad: setupModelViewerUi,
    },
  ]);
}

function setupShopifyXr(errors) {
  if (errors) {
    console.warn(errors);
    return;
  }
  if (!window.ShopifyXR) {
    document.addEventListener('shopify_xr_initialized', function () {
      setupShopifyXr();
    });
    return;
  }

  for (const sectionId in modelJsonSections) {
    if (modelJsonSections.hasOwnProperty(sectionId)) {
      const modelSection = modelJsonSections[sectionId];
      if (modelSection.loaded) continue;

      const modelJson = document.querySelector(`${selectors.modelJson}${sectionId}`);
      if (modelJson) {
        window.ShopifyXR.addModels(JSON.parse(modelJson.innerHTML));
        modelSection.loaded = true;
      }
    }
  }
  window.ShopifyXR.setupXRElements();
}

function setupModelViewerUi(errors) {
  if (errors) {
    console.warn(errors);
    return;
  }

  for (const key in models) {
    if (models.hasOwnProperty(key)) {
      const model = models[key];
      if (!model.modelViewerUi) {
        model.modelViewerUi = new Shopify.ModelViewerUI(model.$element);
      }
      setupModelViewerListeners(model);
    }
  }
}

function setupModelViewerListeners(model) {
  const xrButton = xrButtons[model.sectionId];

  model.$container.addEventListener('pause', function () {
    if (model.modelViewerUi.pause) {
      model.modelViewerUi.pause();
    }
  });
  model.$container.addEventListener('play-desktop', function () {
    if (model.modelViewerUi.play && !isTouch()) {
      model.modelViewerUi.play();
    }
    if (xrButton && xrButton.$element && model && model.modelId && selectors.dataModel3d) {
      xrButton.$element.setAttribute(selectors.dataModel3d, model.modelId);
    }
  });
  model.$container.addEventListener('play', function () {
    if (model.modelViewerUi.play) {
      model.modelViewerUi.play();
    }
  });
}
